'use strict';
const angular = require('angular');

export class PhoneSectionEditComponent {
  /*@ngInject*/
  constructor(SettingsService) {
    this.phones = [];
    this.SettingsService = SettingsService;
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("data")) {
      this.phones = this.config.data ? angular.copy(this.config.data) : [];
    }

    this.SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.phoneTypes = appSettings.data.phoneTypes;

      if (!this.phones || !this.phones.length)
        this.addPhone();
    });
  };


  updatePrimaryPhone(idx) {
    angular.forEach(this.phones, (phone, index) => {
      phone.isPrimary = (idx == index);
    });
  }

  addPhone() {
    this.phones.push({
      type: this.phoneTypes[0],
      number: '',
      isPrimary: !this.phones.length
    })
  }

  removePhone(idx) {
    // Check if the removed phone was the primary one
    let primaryRemoved = this.phones[idx].isPrimary;

    // remove the phone
    this.phones.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.phones.length > 0) {
      this.phones[0].isPrimary = true;
    }
  }

  ok() {
    this.close({$value: this.phones});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.phoneSectionEdit', [])
  .component('phoneSectionEdit', {
    template: require('./phone-section-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: PhoneSectionEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/phone-section-edit/phone-section-edit.component.js